<template>
    <div>
        <new-experimental-dataset-component @submitNewExperimentalDataset="handleSubmitNewExperimentalDataset" :activeExperimentalPlans="activeExperimentalPlans" :duplicateExperimentalDataset="duplicateExperimentalDataset"></new-experimental-dataset-component>
    </div>
</template>


<script>
import NewExperimentalDatasetComponent from '@/components/dataset/NewExperimentalDatasetComponent'
import axios from "axios"
import { mapGetters, mapMutations } from 'vuex'

export default {
    name: "NewExperimentalDataset",
    components: {NewExperimentalDatasetComponent},
    data: function () {
        return {
            component_url: 'experiments/datasets',
            newExperimentalDataset: {},
            activeExperimentalPlans: [],
            duplicateExperimentalDataset: {}
        }
    },
    mounted: function() {
        if (this.$route.params.duplicateExperimentalDataset) {
            this.duplicateExperimentalDataset = this.$route.params.duplicateExperimentalDataset
        }

        this.setBreadcrumb()
        this.getExperimentalPlan()
    },

    computed: {
        ...mapGetters ([
            'base_url', 'auth_header'
        ])
    },

    methods: {
        ...mapMutations([
            'SET_BREADCRUMB', 'CHANGE_EXPERIMENTAL_DATASET_ID'
        ]),
        setBreadcrumb: function(){
            this.SET_BREADCRUMB(this.$route.meta.breadcrumb)
        },
        //set global ExperimentalDatasetId
        setExperimentalDatasetId: function(currentExperimentalDatasetId){
            this.CHANGE_EXPERIMENTAL_DATASET_ID(currentExperimentalDatasetId)
        },
        getExperimentalPlan: function(){

            axios
                .get(`${this.base_url}experiments/plans?archived=False&status=COMPLETED`, {
                    headers: this.auth_header
                })
                .then(response1 => {
                    axios
                        .get(`${this.base_url}experiments/plans?archived=False&status=LOCKED`, {
                            headers: this.auth_header
                        })
                        .then(response2 => {
                            this.activeExperimentalPlans = [...response1.data, ...response2.data];
                            console.log("Active ExperimentalPlans json: ")
                            console.log(this.activeExperimentalPlans)
                            this.getValidationPlanTemplates()
                            this.getMethod()
                        })
                        .catch(error => {
                            console.log("Something went wrong getting the Experimental Plans :(", error);
                        })
                })
                .catch(error => {
                    console.log("Something went wrong getting the Experimental Plans :(", error);
                })
        },
        getValidationPlanTemplates: function() {
            this.activeExperimentalPlans.forEach(plan => {
                axios
                    .get(`${this.base_url}experiments/templates/${plan.template.id}`, {
                        headers: this.auth_header
                    })
                    .then(response => {
                        plan.template = response.data
                    })
                    .catch(error => {
                        console.log("Something went wrong getting the ValidationPlanTemplates :(", error);
                    })
            })
        },
        getMethod: function(experimentalPlan) {
            this.activeExperimentalPlans.forEach(plan => {
                axios
                    .get(`${this.base_url}experiments/methods/${plan.method.id}`, {
                        headers: this.auth_header
                    })
                    .then(response => {
                        plan.method = response.data
                    })
                    .catch(error => {
                        console.log("Something went wrong getting the methods :(", error);
                    })
            })
        },
        handleSubmitNewExperimentalDataset: function(newExperimentalDataset) {
            axios
                .post(
                    this.base_url + this.component_url,
                    newExperimentalDataset,
                    { 
                        headers: this.auth_header
                    }
                )
                .then(response => {
                    console.log("Experimental Dataset Successfully Created", response);
                    // this.loading = false;
                    // this.$toast.open({
                    //     duration: 5000,
                    //     message: `Experimental Dataset Successfully Created`,
                    //     position: 'is-top',
                    //     type: 'is-primary'
                    // })
                    this.setExperimentalDatasetId(response.data.id)
                    this.$router.push({ name: "UploadExperimentalDataset", params: {id: response.data.id } });
                })
                .catch(error => {
                    this.loading = false;
                    this.$toast.open({
                        duration: 5000,
                        message: `Experimental Dataset was not successfully Created`,
                        position: 'is-top',
                        type: 'is-danger'
                    })
                    console.log("Experimental Dataset was not successfully Created", error.response.data);
                });
        }
    }
}
</script>
